module.exports = __webpack_public_path__ + "img/google.40576ec2.png";